export default __webpack_public_path__ + "static/media/icon-package.d28136dd.svg";